import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router'
import { APP_ROUTES } from '@/common/constants'
import { APP } from '@/common/strings'
import { analytics } from '@/common/analytics/analytics'
import { ONBOARDING_COPY } from '@/locales/en'
import { useEffect } from 'react'
import useUserStore from '@/user/userStore'
import { MobileForm } from './features/mobile/components/MobileForm'
import { useMobileLogic } from './features/mobile/useMobileLogic'
import { useOnboardingProgress } from './useOnboardingProgress'

export function MobileNumberPage() {
    const navigate = useNavigate()
    const { progress } = useOnboardingProgress()
    const { user } = useUserStore()
    const { data, saving, isSuccess, createUserData, onSubmit } = useMobileLogic()

    useEffect(() => {
        if (!isSuccess || !createUserData) return

        analytics.trackWithDefaults('onboarding_mobile_and_DOB_submitted')

        const normalize = (num: string) => num.replace(/\D/g, '')
        const currentMobile = normalize(createUserData.mobile || '')
        const mobileInput = normalize(user?.mobile || '')

        if (currentMobile && mobileInput === currentMobile) {
            navigate(APP_ROUTES.SURVEY)
        } else {
            navigate(APP_ROUTES.MOBILE_VERIFICATION)
        }
    }, [isSuccess, createUserData, user, navigate])

    const handleBack = () => {
        navigate(APP_ROUTES.ADDRESS)
    }

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.aboutYou.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <MobileForm
                progress={progress}
                defaultValues={data}
                saving={saving}
                onSubmit={onSubmit}
                onBack={handleBack}
                disabled={saving}
            />
        </>
    )
}
